<template>
  <!-- Navbar -->
  <nav
    class="absolute top-0 left-0 w-full z-10 md:flex-row md:flex-nowrap md:justify-start flex items-center p-3 bg-blue-500"
  >
    <div
      class="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap px-2"
    >
      <div class="flex flex-row space-x-4 items-center">
        <img src="@/assets/img/wyci.png" class="w-12 h-12 rounded-lg" />
        <!-- Brand -->
        <router-link
          class="text-left pb-0 text-white text-2xl"
          to="/scm/home">
          <div class="text-2xl font-bold">㈜화영 공급자망 관리 시스템</div>
          <div class="text-base">WHAYOUNG Supply Chain Management System</div>
        </router-link>
      </div>

      <!-- User -->
      <ul class="flex items-center w-128">
        <user-dropdown />
      </ul>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script setup>
import UserDropdown from "@/components/layouts/UserDropdown.vue";
</script>
